import type { OfferAdvantage } from '../types';

interface OfferAdvantagesProps {
  items: OfferAdvantage[];
}

export function OfferAdvantages({ items }: OfferAdvantagesProps) {
  return (
    <div className="flex w-full flex-col gap-2 rounded-[24px] bg-white p-4">
      {items.map((item) => (
        <div key={item.lead} className="flex w-full items-center gap-2">
          <div className="flex size-[52px] shrink-0 items-center justify-center rounded-[26px] bg-mf-neutral-50 p-3">
            <img src={item.icon} alt="" className="size-7 object-contain" />
          </div>
          <p className="min-w-0 flex-1 font-body text-sm font-normal leading-4 text-mf-neutral-600">
            {item.before}
            <span className="font-bold text-mf-neutral-900">{item.lead}</span>
            {item.after}
          </p>
        </div>
      ))}
    </div>
  );
}
